export class GenericModel {

    protected fromJson(json?: any): boolean {
        return this.isValid();
    }

    protected isValid(): boolean {
        return false;
    }
}